import React, {useState, useEffect} from 'react';

import IconSelector from '@ibibo/icon-selector';
import {defaultTheme} from '@ibibo/build-theme';

import * as S from '../MySafety/MySafety.styles';
import * as P from './PerfectStay.styles';

import apartmentImg from './assets/apartment.png';
import homestayImg from './assets/homestay.png';
import hotelImg from './assets/hotel.png';
import resortImg from './assets/resort.png';
import villaImg from './assets/villa.png';

const iconProps = {
  fill: defaultTheme.colors.blue.dark,
  width: '2.8rem',
  height: '2.8rem'
}

const MySafety = () => {
  const [data, setData] = useState ([{
    img: '',
    title: 'HOTEL'
  }, {
    img: '',
    title: 'HOMESTAY'
  },
  {
    img: '',
    title: 'RESORT'
  }, {
    img: '',
    title: 'VILLA'
  }, {
    img: '',
    title: 'APARTMENT'
  }]);

  useEffect(() => {
    setData([{
      img: hotelImg,
      title: 'HOTEL'
    }, {
      img: homestayImg,
      title: 'HOMESTAY'
    },
    {
      img: resortImg,
      title: 'RESORT'
    }, {
      img: villaImg,
      title: 'VILLA'
    }, {
      img: apartmentImg,
      title: 'APARTMENT'
    }]);
  }, [])

  return (
    <S.MySafetyBlockWrapper>
      <P.StayBlockInner>
        <S.BenefitHeader>Find a perfect stay</S.BenefitHeader>
        <S.BenefitSubHeader>Helping you find a perfect stay for everyone</S.BenefitSubHeader>
        <S.MySafetyWrapper>
          <S.MySafetyBlock>
            {data.map(item => <P.StayBlockWrapper key={item.title}>
              <P.StayImageBlock src={item.img ? item.img : null} alt=""></P.StayImageBlock>
              <S.TextWrapper>{item.title}</S.TextWrapper>
            </P.StayBlockWrapper>)}
          </S.MySafetyBlock>
        </S.MySafetyWrapper>
      </P.StayBlockInner>
    </S.MySafetyBlockWrapper>
  );
};

export default MySafety;
